export function getDateStringFromEventDays(startDateTime?: string, endDateTime?: string) {
    if (!startDateTime && !endDateTime) {
        return '';
    }

    if (!endDateTime || startDateTime.substring(0, 10) === endDateTime.substring(0, 10)) {
        const day = startDateTime.substring(8, 10);
        const month = startDateTime.substring(5, 7);

        const startTime = startDateTime.substring(11, 16);
        const endTime = endDateTime?.substring(11, 16);
        if (endTime) {
            return `${parseInt(day)}.${parseInt(month)}. ${startTime} - ${endTime}`;
        } else {
            return `${parseInt(day)}.${parseInt(month)}. ${startTime}`;
        }
    }

    const startDate = startDateTime.substring(8, 10);
    const startMonth = startDateTime.substring(5, 7);

    const endDate = endDateTime.substring(8, 10);
    const endMonth = endDateTime.substring(5, 7);

    return `${parseInt(startDate)}.${parseInt(startMonth)}. - ${parseInt(endDate)}.${parseInt(
        endMonth
    )}.`;
}
